import { UilMinusCircle, UilPlusCircle } from '@iconscout/react-unicons'
import { PartNoDiv, PartNoButton } from './styledComponents'
import { TableNumberButton } from '$globalStyledComponents/Table'
import TextHighlighter from '$components/TextHighlighter'
import { theme, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import Tooltip from '$components/Tooltip'
import PropTypes from 'prop-types'

const { useToken } = theme

const ProcessingIndicator = ({ part }) => {
  const { t } = useTranslation()
  const isProcessing =
    part.png_status === 'processing' ||
    part.vectorization_status === 'processing'

  if (!isProcessing) return null

  const tooltipText =
    part.png_status === 'processing'
      ? t('part_3d_file_upload.generating_preview_png')
      : t('processing_3d_model', 'Processing 3D model...')

  return (
    <Tooltip title={tooltipText}>
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 12 }} spin />}
        size="small"
        style={{ marginRight: 6 }}
      />
    </Tooltip>
  )
}

ProcessingIndicator.propTypes = {
  part: PropTypes.shape({
    png_status: PropTypes.string,
    vectorization_status: PropTypes.string,
  }).isRequired,
}

const PartNo = ({ part, expandedRowKeys, onExpand, filters = [] }) => {
  const { token } = useToken()
  if (typeof expandedRowKeys === 'object') {
    const expanded = expandedRowKeys.includes(part.id)
    return (
      <PartNoButton
        onClick={() => {
          onExpand(!expanded, part)
        }}
      >
        <ProcessingIndicator part={part} />
        {expanded ? (
          <UilMinusCircle
            size="15"
            color={token.colorPrimary}
            style={{ margin: '0px 5px -3px -5px' }}
          />
        ) : (
          <UilPlusCircle
            size="15"
            color={token.colorPrimary}
            style={{ margin: '0px 5px -3px -5px' }}
          />
        )}
        <TableNumberButton>
          <TextHighlighter text={part.id_part_client} filters={filters} />
        </TableNumberButton>
      </PartNoButton>
    )
  }

  return (
    <PartNoDiv>
      <ProcessingIndicator part={part} />
      <TableNumberButton>
        <TextHighlighter text={part.id_part_client} filters={filters} />
      </TableNumberButton>
    </PartNoDiv>
  )
}

PartNo.propTypes = {
  part: PropTypes.shape({
    id: PropTypes.string,
    id_part_client: PropTypes.string,
    png_status: PropTypes.string,
    vectorization_status: PropTypes.string,
  }).isRequired,
  expandedRowKeys: PropTypes.arrayOf(PropTypes.string),
  onExpand: PropTypes.func,
  filters: PropTypes.array,
}

export default PartNo
